import React, { useEffect, useState } from 'react';
import { Button, Row, Col, Modal, Tooltip, OverlayTrigger, Accordion, Card } from 'react-bootstrap'
import AuthService from "../controllers/AuthService";
import UserService from "../controllers/UserService";
import MultiCarouselPage from './MultiCarouselPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import $ from 'jquery'


    
const ReportEvaluateStudentResult = props => {

    const [name, setName] = useState('');
    const [headline, setHeadline] = useState('เราเห็นอุปนิสัยเชิงบวกอะไรบ้าง');
    const [description, setDescription] = useState('หลายเรื่องราวที่ผ่านเข้ามาในชีวิตของเรามันทำให้เรามองเห็นอุปนิสัยเชิงบวกข้อไหนบ้าง?');  
    const [question, setQuestion] = useState('อุปนิสัยเชิงบวกในตัวของคุณ');     
    const [questionTextBox, setQuestionTextBox] = useState('เหตุการณ์ที่ทำให้คุณครูมองเห็นอุปนิสัยเชิงบวกของเรา');    
    const [questionTextBox1, setQuestionTextBox1] = useState('อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา');    
    const [questionTextBox2, setQuestionTextBox2] = useState('เพื่อนๆ เห็นอะไรในตัวเรา?');   
    const [questionTextBox3, setQuestionTextBox3] = useState('เพื่อนๆ เห็นอะไรในตัวเรา?');   
  
    const [data1, setData1] = useState([]);
    const [testSelf, setTextSelf] = useState([]);
    const [strengths, setStrengths] = useState([]);

    const [target, setTarget] = useState([]);

    const [showFriendMode, setShowFriendMode] = useState('');
    const [showNotFriendMode, setShowNotFriendMode] = useState('');
    const [data2, setData2] = useState([]);
    const [data3, setData3] = useState([]);
    const [text1, setText1] = useState([]);
  

    const responsive3 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            // partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }
    const responsive2 = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            partialVisibilityGutter: 40 // this is needed to tell the amount of px that should be visible.
        },
        tablet: {
            breakpoint: { max: 1024, min: 500 },
            items: 2,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        },
        mobile: {
            breakpoint: { max: 500, min: 0 },
            items: 1,
            partialVisibilityGutter: 100 // this is needed to tell the amount of px that should be visible.
        }
    }


    useEffect(() => {
        
        const student = props.currentStudentId;
        const roomId = props.roomId;
        // console.log('test');
        // console.log(student);
        let doneStatus = false;
        let newStrengths = []
      
        var user = AuthService.getCurrentUser();
        //todo ปีการศึกษา        
        var filter = {};      
        UserService.getRoomDetail(roomId).then((response) => {                 
            filter = {
                "domain": user.domain.name,
                "roomId": roomId,
                "year": response.data.data.year,
                "term": response.data.data.term,                    
            }; 
        }).then(() => { 


        UserService.getStrengths().then((response) => {
            setStrengths(response.data.data)
            
            for (const [index, str] of response.data.data.entries()) { 
                newStrengths[str.id] = {
                    image: str.imageUrl,
                    name: str.name,
                    description: str.description
                }
            }
            // setReStrengths(newStrengths)
            return response.data.data
        }).then((apiStrengths) => {
            UserService.getFriendShipList(student, filter).then(        
                (res) => {            
               
                var images0 = [];   
                var images1 = [];  
                var images2 = [];  
                var text1 = [];
                var stringHtml;     
                var allAnswer0 = [];      
                var allAnswer1 = [];  
                var allAnswer2 = [];  
                var allAnswer3 = [];        
                var selfText = '';
                var key = '';
                var isTarget = true;
               
                // console.log(res.data.data[0].others);

            if(props.code === 'studentself'){
                setHeadline('ผลประเมินจากมุมมองตัวเอง'); 
                setDescription('ในช่วงที่ผ่านมา มีเหตุการณ์มากมายที่เกิดขึ้นกับ ตัวเรา แล้วจากเหตุการณ์ที่ผ่านมาทั้งหมดนั้นทำให้เรามองเห็นอุปนิสัยเชิงบวกอะไรเกิดขึ้นในตัวเองบ้าง? ลองเล่าให้ฟังหน่อยนะคะ'); 
                setQuestion('อุปนิสัยเชิงบวกในตัวของคุณ'); 
                setQuestionTextBox('เหตุการณ์ที่ทำให้เรามองเห็นอุปนิสัยเชิงบวกของตัวเอง'); 
                setQuestionTextBox1('');
                setQuestionTextBox2('');
                setQuestionTextBox3('');

            } else if (props.code === 'studentteacher') {
                setHeadline('ผลประเมินจากมุมมองของคุณครู'); 
                setDescription('หลายเรื่องราวที่ผ่านเข้ามาในชีวิตของเรามันทำให้คุณครูมองเห็นอุปนิสัยเชิงบวกข้อไหนของเราบ้าง?'); 
                setQuestion('อุปนิสัยเชิงบวกในตัวของคุณ'); 
                setQuestionTextBox('เหตุการณ์ที่ทำให้คุณครูมองเห็นอุปนิสัยเชิงบวกของเรา'); 
                setQuestionTextBox1('');
                setQuestionTextBox2('');
                setQuestionTextBox3('');
            } else {
                setHeadline('ผลประเมินจากมุมมองเพื่อนๆ'); 
                setDescription('หลายเรื่องราวที่ผ่านเข้ามาในชีวิตของเรามันทำให้เพื่อนๆ มองเห็นอุปนิสัยเชิงบวกข้อไหนของเราบ้าง?'); 
                var tempHtml = `<img src='/images/evaluate/search.png' class="evaluate-search"/>อุปนิสัยเชิงบวกที่มองเห็น<span class="doNotWrap">ในช่วงที่ผ่านมา</span>` ;
                var temp = <div dangerouslySetInnerHTML={{ __html: tempHtml}} />

                setQuestion(temp); 
                setQuestionTextBox(''); 
                setQuestionTextBox1('อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา');
                setQuestionTextBox2('อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา');
                setQuestionTextBox3('เพื่อนๆ เห็นอะไรในตัวเรา?');
            }  
            if (props.code === 'studentself') {
                setTarget('me')
            } else if (props.code === 'studentteacher') {
                setTarget('teacher')
            }else if (props.code === 'studentfriend') {
                setTarget('friends')
            }
            
            if(props.code === 'studentself' || props.code === 'studentteacher') {
                for (const [index, aAnswer] of res.data.data[0].others.entries()) {  

                    var friendMode = false;
                    console.log(props.code);
                    if(props.code === 'studentself'){
                        key = 'student';
                        isTarget =  aAnswer.user.id === student;
                        friendMode = false;
                        setShowNotFriendMode('');
                        setShowFriendMode('d-none');
                    } else if (props.code === 'studentteacher') {
                        key = 'teacher';
                        isTarget = true;
                        friendMode = false;
                        setShowNotFriendMode('');
                        setShowFriendMode('d-none');
                    }

                    if(aAnswer.user.roles[0].toLowerCase() ===  key && aAnswer.answerAt !== null && isTarget &&  !friendMode){           

                       
                            doneStatus = true;
                            // allAnswer0[aAnswer.answers[0].values[0]] = 1;
                            // allAnswer0[aAnswer.answers[1].values[0]] = 1;
                            // allAnswer0[aAnswer.answers[2].values[0]] = 1;      

                            allAnswer0[0] = aAnswer.answers[0].values[0];
                            allAnswer0[1] = aAnswer.answers[1].values[0];
                            allAnswer0[2] = aAnswer.answers[2].values[0];  
                            
                            selfText = aAnswer.answers[3].values[0];
                            setTextSelf(selfText);;

                            var indextTemp = 0;
                            const headline = ['อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา',
                            'อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา',
                            'อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา'
                            ]
                            allAnswer0.forEach(async function(ansTemp, i) {                               
                                stringHtml = `<div class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${ansTemp}.png' class="d-inline w-100  cardimage i0${indextTemp}" />`;
                                var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i0-${indextTemp}" onClick={() => { cardClick(ansTemp, '.tab0', newStrengths[ansTemp], '.i0'+ansTemp, headline[i] ) }}/>
                                images0.push(temp);
                                indextTemp++;
                              })                              
                            
                    }

                   
                   
                }                             
            } else {    
                    setShowNotFriendMode('d-none');
                    setShowFriendMode('');
                    setTextSelf('');
                    var calIndex = 0;  
                    for (const [index, aAnswer] of res.data.data[0].others.entries()) { 
                        // console.log(aAnswer);    
    
                        if(aAnswer.user.roles[0].toLowerCase() !==  'teacher' &&  aAnswer.user.id  !== student && aAnswer.answerAt !== null){            
    
                            // if(allAnswer0[aAnswer.answers[0].values[0]] === undefined){
                            //     allAnswer0[aAnswer.answers[0].values[0]] = 1;
                            // } else {
                            //     allAnswer0[aAnswer.answers[0].values[0]]++
                            // }
                        
                            // if(allAnswer1[aAnswer.answers[1].values[0]] === undefined){
                            //     allAnswer1[aAnswer.answers[1].values[0]] = 1;
                            // } else {
                            //     allAnswer1[aAnswer.answers[1].values[0]]++
                            // }
    
    
                            // if(allAnswer2[aAnswer.answers[2].values[0]] === undefined){
                            //     allAnswer2[aAnswer.answers[2].values[0]] = 1;
                            // } else {
                            //     allAnswer2[aAnswer.answers[2].values[0]]++
                            // }
                    

                            if(allAnswer0[aAnswer.answers[0].values[0]] === undefined){
                                allAnswer0[aAnswer.answers[0].values[0]] = 1;
                            } else {
                                allAnswer0[aAnswer.answers[0].values[0]]++
                            }
                        
                            if(allAnswer0[aAnswer.answers[1].values[0]] === undefined){
                                allAnswer0[aAnswer.answers[1].values[0]] = 1;
                            } else {
                                allAnswer0[aAnswer.answers[1].values[0]]++
                            }
    
    
                            if(allAnswer0[aAnswer.answers[2].values[0]] === undefined){
                                allAnswer0[aAnswer.answers[2].values[0]] = 1;
                            } else {
                                allAnswer0[aAnswer.answers[2].values[0]]++
                            }
                    
                    
                    
                            if(props.studentId === aAnswer.user.id){
                                selfText = aAnswer.answers[3].values[0];
                                setTextSelf(selfText);
                            } else {                            
                                
                                allAnswer3[calIndex] = {
                                    'code': calIndex,
                                    'text': aAnswer.answers[3].values[0]
                                }  
                                calIndex++;
                            }
                        
                        }
                    }   

                    var myArr0 = Object.fromEntries(
                        Object.entries(allAnswer0).sort(([, a], [, b]) => b - a)
                    );
                    
                    Object.keys(myArr0).map((aArray, i) => {
                        // tempPercent = res.data.data.percentages[aArray]
                        // stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer0[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                        if(allAnswer0[aArray] <= 1 ){
                            stringHtml = `<div class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                        } else {
                            stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer0[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
    
                        }
                        var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i0-${i}" onClick={() => { cardClick(aArray, '.tab0', newStrengths[aArray], '.i0'+aArray, '' ) }}/>
                        images0.push(temp);
                    })    
            
                    // var myArr1 = Object.fromEntries(
                    //     Object.entries(allAnswer1).sort(([, a], [, b]) => b - a)
                    // );
                    
                    // Object.keys(myArr1).map((aArray, i) => {
                    //     // tempPercent = res.data.data.percentages[aArray]
                    //     // stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer1[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i1${aArray}" />`;
                        
                    //     if(allAnswer1[aArray] <= 1 ){
                    //         stringHtml = `<div class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                    //     } else {
                    //         stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer1[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
    
                    //     }
    
                    //     var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i1-${i}" onClick={() => { cardClick(aArray, '.tab1', newStrengths[aArray], '.i1'+aArray ) }}/>
                    //     // images1.push(temp);
                    //     images0.push(temp);
                    // })    
    
                    // var myArr2 = Object.fromEntries(
                    //     Object.entries(allAnswer2).sort(([, a], [, b]) => b - a)
                    // );
                    
                    // Object.keys(myArr2).map((aArray, i) => {
                    //     // tempPercent = res.data.data.percentages[aArray]
                    //     // stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer2[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i2${aArray}" />`;
                    //     if(allAnswer2[aArray] <= 1 ){
                    //         stringHtml = `<div class="primary-text percent-font" data-value="1"><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
                    //     } else {
                    //         stringHtml = `<div class="primary-text percent-font" data-value="1"><button type="button" class="btnin-card btn font-sarabun-bold"><img src='/images/evaluate/card_icon.png' class="mr-1 img-cardicon"/> ${allAnswer2[aArray]}</button><img src='/images/strengths/cards/${aArray}.png' class="d-inline w-100  cardimage i0${aArray}" />`;
    
                    //     }
                    //     var temp = <div dangerouslySetInnerHTML={{ __html: stringHtml }} className="anywhere-wrap d-relative carousel-div" key="i2-${i}" onClick={() => { cardClick(aArray, '.tab2', newStrengths[aArray], '.i2'+aArray ) }}/>
                    //     // images2.push(temp);
                    //     images0.push(temp);
                    // })    
    
                    const itemsText = [];          
                    
                    for (const [index, value] of  allAnswer3.entries()) {    
                        var temp = `<div class="border-radius-12 div-ans p-3" data-value="1"><div class="item text-left">${value.text}</div></div>`;
                        temp = <div dangerouslySetInnerHTML={{ __html: temp }} class="anywhere-wrap" key="t-${index}" />
                        itemsText.push(temp);               
                    }
                    setText1(itemsText);       
                
            }    
                return [images0, images1, images2];

            }).then((res) => {              
                setData1(res[0]);   
                setData2(res[1]); 
                setData3(res[2]);         
             
            }).then((res) => {     
                // myloop();            
            })
        });

    });
    }, [])
    

    const goto = (target, newTab = false) => {
        if (target && newTab) { 
            window.open(target, '_blank').focus();
        } 
    }
        return (
            <div>                
                <div>
                <Row className="bg-light-blue">
                    <Col xs={12} md={12}  className="w-100 text-center pt-4 ">
                        <h2 class="font-sarabun-bold primary-text " >{ headline }</h2>
                    </Col>   
                </Row>
                <Row style={{"paddingBottom": "17px"}} className="bg-light-blue">                
                    <Col className="main-evaluate-overview pb-3">                        
                        <Row>                                           
                            <Col xs={12} md={12} className="w-100 m-center-d-left pt-3">
                                <h4 class="font-sarabun-bold text-left">{ description }</h4>
                            </Col>              
                            <Col xs={12} md={12} className="w-100 text-center pt-3">
                                <Button className="bluesky d-inline py-1 py-md-2 px-4 bt font-sarabun-bold btn btn-primary export-btn m-auto" ><h5 className="mb-0 font-weight-bold" onClick={() => goto(`/report/friendship/export/${target}/${props.roomId}/${props.currentStudentId}`, true) }>Export</h5></Button>
                            </Col>          
                        </Row>
                    </Col>                   
                </Row>               
                <Row className="pt-3 pb-5 report-tab">
                    <Col className="main-evaluate-overview">        
                        <Row>
                            <Col>
                                {/* <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search"/> {question}</h4> */}
                                <h4 class="font-sarabun-bold">{question}</h4>
                            
                            </Col>
                        </Row>           
                        <Row className="py-0 bg-white mx-0">
                            <Col className="px-0">
                                <MultiCarouselPage data={data1} responsive={data1.length > 3 ? responsive2 : responsive3} />                          
                            </Col>
                        </Row>
                        <Row className="py-3 bg-white mx-0 tab0 tab">
                        </Row>
                  
                        <Row className={showNotFriendMode}>
                            <Col className="w-100 px-4">                               
                                <h4 class="font-sarabun-bold  text-center">{ questionTextBox }</h4>
                            </Col>
                        </Row>
                        <Row className={showNotFriendMode}>
                            <Col className="w-100 px-4 pt-0">                               
                                <div className='border-radius-12 border-blue p-3 text-left overflow-7 div-ans auto-height'>
                                    <div className='font-sarabun'>{testSelf}</div>
                                </div>
                            </Col>
                        </Row>       

                        <div className={showFriendMode}>
                            {/* <Row>
                                <Col className="w-100 text-center pt-3">                           
                                    <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search"/>  {questionTextBox1}</h4>
                                </Col>
                            </Row>
                            <Row className="py-3 bg-white mx-0">
                                <Col className="px-0">
                                    <MultiCarouselPage data={data2}  responsive={data2.length > 3 ? responsive2 : responsive3} />                           
                                </Col>
                            </Row>
                            <Row className="py-3 bg-white mx-0 tab1 tab">
                            </Row>
                            <Row>
                                <Col className="w-100 text-center pt-3">                           
                                <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search"/>  {questionTextBox2}</h4>
                                </Col>
                            </Row>
                            <Row className="py-3 bg-white mx-0">
                                <Col className="px-0">
                                    <MultiCarouselPage data={data3} responsive={data3.length > 3 ? responsive2 : responsive3} />                           
                                </Col>
                            </Row>
                            <Row className="py-3 bg-white mx-0 tab2 tab">
                            </Row> */}
                            <Row>
                                <Col className="w-100 text-center pt-3">                           
                                    <h4 class="font-sarabun-bold">{questionTextBox3}</h4>
                                </Col>
                            </Row>
                            <Row className="py-3 bg-white mx-0">
                                <Col className="px-0">
                                    <MultiCarouselPage data={text1} responsive={responsive3} />
                                </Col>
                            </Row>
                        </div>            
                    </Col>
                </Row>              

                </div>
            </div>
        )

        
        function cardClick(key, tab, str, ele, headline = ''){
            
            $('.tab').html('');    
           

            // if($('body').find(ele).hasClass( "border-card")){              
            $('body').find('.cardimage').removeClass( "border-card");
            // }
            if (headline) {
                headline = `<h5 class="font-sarabun-bold font-default">${headline}</h5>`
            }
            $('body').find(ele).addClass( "border-card");
            $(tab).html('<div class="str-div">' + headline + '<h5 class="font-sarabun-bold">' + str.name +'</h5><h6>' + str.description + '</h6></div>');
           
        }
}

export default ReportEvaluateStudentResult